import React, { type Ref, useImperativeHandle, useRef, useState, forwardRef, useEffect } from 'react';
import styles from './FJExpansionInput.module.less';

interface InputRefProps {
    getValue: () => string;
}

interface Props {
    initValue?: string;
    renderExpansion?: () => React.ReactNode;
    maxLength?: number;
    onChange?: (value: string) => void;
    placeholder?: string;
    footHeight?: number;
}

const FJExpansionInput = (
    { initValue = '', renderExpansion, maxLength, placeholder, footHeight = 30, onChange }: Props,
    ref: Ref<InputRefProps>,
) => {
    const inputRef = useRef<HTMLTextAreaElement>(null);

    const [value, setValue] = useState('');

    const _onChange = e => {
        const value = e.target.value;
        setValue(value);
        onChange?.(value);
    };

    useEffect(() => {
        setValue(initValue);
    }, [initValue]);

    useImperativeHandle(ref, () => ({
        getValue: () => {
            return value;
        },
        updateValue: (value: string) => {
            setValue(value);
        },
    }));

    return (
        <div className={styles.box}>
            <textarea
                ref={inputRef}
                className={styles.input}
                maxLength={maxLength}
                value={value}
                placeholder={placeholder}
                onChange={_onChange}
            />
            <div className={styles.foot} style={{ height: footHeight }}>
                <p className={styles.text_number}>{`${value.length}/${maxLength}`}</p>
                {renderExpansion?.()}
            </div>
        </div>
    );
};

export default forwardRef<InputRefProps, Props>(FJExpansionInput);
